<template>

  <div id="toast">
    <transition name="toast" appear>
      <div v-if="showing" class="toast-wrapper">
        <div class="toast" :class="type" @click="dismiss">{{ message }}
          <v-btn v-if="action" @click="action.function" flat>{{ action.title }}</v-btn>
        </div>
      </div>
    </transition>
  </div>

</template>

<script>

  export default {
    data () {
      return {
        action: false,
        duration: 4000,
        message: '',
        position: 'left',
        isInfinity: false,
        showing: false,
        type: 'notify',
        timeout: false
      }
    },
    methods: {
      show (message, type, params) {
        
        // Required
        if (!message || !type) {
          console.log('Toast error: Missing parameter:', '\nmessage:', !message, '\ntype:', !type, '\n\nExpected Snackbar.show(String(type), String(message), Object(params))\n\nParams:', params)
          return
        }

        if (this.timeout) {
          this.dismiss();
          setTimeout(function () {
            this.show(message, type, params);
          }.bind(this), 300);
          return;
        }

        this.message = message
        this.type = type

        for (var key in this.types) {
          this.types[key] = key === this.type
        }

        // Optional
        params = params || {}
        this.isInfinity = params.duration && params.duration === 'infinity'
        this.position = params.position || 'left'
        this.duration = params.duration && params.duration !== 'infinity' ? params.duration : 4000

        // Optional: Action
        if (params.action) {
          if (params.action.function && params.action.title) this.action = params.action
          else {
            console.log('Toast Action error: Action missing parameter:', 'action.function:', !params.action.hasOwnProperty('function'), 'action.title:', !params.action.hasOwnProperty('title'))
            return
          }
        }

        // Engage
        this.showing = true
        if (this.duration !== 'infinity') {
          this.timeout = setTimeout(function () {
            this.dismiss();
          }.bind(this), this.duration);
        }
      },
      showError (e) {
        var message = '';
        if (_.isString(e)) message = e;
        else if (e && e.error && e.error.message) message = e.error.message;
        else message = 'Something went wrong.';
        this.show(message, 'error');
      },
      dismiss () {
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = false;
        this.showing = false;
      }
    },
    created () {
      window.Toast = this;
    }
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';
  @import '../css/transitions.scss';

  #toast {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    overflow: hidden;

    .toast-wrapper {

      position: fixed;
      bottom: 0;
      left: 0;
      max-width: 400px;
      padding: 16px;
      box-sizing: border-box;

      .toast {
        @include fontPrimary400();
        word-wrap: break-word;
        
        pointer-events: auto;
  
        cursor: pointer;
        padding: 16px;
        background: $error_red;
        border-radius: 5px;
        color: $white;
    
        box-shadow: $cardShadow;

        &.error {
          background: $error_red !important;
        }

        &.notify {
          background: #888 !important;
        }

        &.success {
          background: $success_green !important;
        }
      }

    }
  }

</style>


// WEBPACK FOOTER //
// src/components/Toast.vue